import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminSettingsList from "@/features/settings/components/admin/AdminSettingsList";
import { useSettingsPermissions } from "@/pages/admin/settings";

export const Route = createFileRoute("/app/admin/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanViewAllSettingTags, userCanEditAllSettingTags } = useSettingsPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Settings", link: null },
        ]}
      />
      <h1>Setting Tag Management</h1>

      {userCanViewAllSettingTags && (
        <p>
          <Button
            color="primary"
            component={Link}
            to={`/app/admin/settings/new`}
            variant="contained"
            size="small"
            disabled={!userCanEditAllSettingTags}
          >
            Add Setting
          </Button>
        </p>
      )}

      <AdminSettingsList
        itemsPerPage={25}
        renderVersion={0}
        tableSize="medium"
        userCanViewAllSettingTags={userCanViewAllSettingTags}
      />
    </>
  );
}
